import * as types from '@/store/types'
export default {
    loadMessageRating(context, payload) {
        context.messageRating = payload
    },
    loadMessageSendInfo(context, payload) {
        context.messagesSendInfo.output = payload.output
        context.messagesSendInfo.input = payload.input
        context.messagesSendInfo.mailing = payload.mailing
        context.messagesSendInfo.labels = payload.labels
    },
    loadMessageSendInfoOutput(context, payload) {
        context.messagesSendInfo.output = payload.messages
        context.messagesSendInfo.labels = payload.labels
        context.messagesToday.output = payload.messagesToday
        context.loadedMessagesOutput = true
    },
    setValueMessagesOutput(context, payload) {
        context.loadedMessagesOutput = payload
    },
    loadMessageSendInfoInput(context, payload) {
        context.messagesSendInfo.input = payload.messages
        context.messagesSendInfo.labels = payload.labels
        context.messagesToday.input = payload.messagesToday
        // console.log(context.messagesToday.output)
        context.loadedMessagesInput = true
    },
    setValueMessagesInput(context, payload) {
        context.loadedMessagesInput = payload
    },
    loadMessageSendInfoMailing(context, payload) {
        context.messagesSendInfo.mailing = payload.messages
        context.messagesSendInfo.labels = payload.labels
        context.messagesToday.mailing = payload.messagesToday
        context.loadedMessagesMailing = true
    },
    loadClientsSubscribeInfo(context, payload) {
        context.clientsInfo.subscribe = payload.subscribe
        context.clientsInfo.labels = payload.labels
        context.clientsToday.subscribe = payload.clientsToday
        context.loadedClientsSubscribe = true
    },
    setValueClientsSubscribe(context, payload) {
        context.loadedClientsSubscribe = payload
    },
    loadClientsUnsubscribeInfo(context, payload) {
        context.clientsInfo.unsubscribe = payload.unsubscribe
        context.clientsInfo.labels = payload.labels
        context.clientsToday.unsubscribe = payload.clientsToday
        context.loadedClientsUnsubscribe = true
    },
    setValueClientsUnsubscribe(context, payload) {
        context.loadedClientsUnsubscribe = payload
    }
}
